import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgButtonArrowForward = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M16.8438 5.06677L35.0005 24.4999",
		stroke: "currentColor",
		strokeWidth: 4,
		strokeLinecap: "round"
	}), /* @__PURE__ */ _jsx("line", {
		x1: 35,
		y1: 24.8284,
		x2: 15.8283,
		y2: 44.0002,
		stroke: "currentColor",
		strokeWidth: 4,
		strokeLinecap: "round"
	})]
});
export default SvgButtonArrowForward;
